import { render, staticRenderFns } from "./SociosNegocio.vue?vue&type=template&id=d3b17a22&"
import script from "./SociosNegocio.vue?vue&type=script&lang=js&"
export * from "./SociosNegocio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports